import {TSSerializable} from './TSSerializable';

export default class TSGeoadminSearchResponse implements TSSerializable<TSGeoadminSearchResponse> {

    private _origin: string;

    private _layerBodId: string;

    private _featureId: string;

    private _detail: string;

    private _rank: string;

    private _geom_st_box2d: string;

    private _num: string;

    private _y: string;

    private _x: string;

    private _lat: string;

    private _lon: string;

    private _label: string;

    private _name: string;

    public get origin(): string {
        return this._origin;
    }

    public set origin(value: string) {
        this._origin = value;
    }

    public get layerBodId(): string {
        return this._layerBodId;
    }

    public set layerBodId(value: string) {
        this._layerBodId = value;
    }

    public get featureId(): string {
        return this._featureId;
    }

    public set featureId(value: string) {
        this._featureId = value;
    }

    public get detail(): string {
        return this._detail;
    }

    public set detail(value: string) {
        this._detail = value;
    }

    public get rank(): string {
        return this._rank;
    }

    public set rank(value: string) {
        this._rank = value;
    }

    public get geom_st_box2d(): string {
        return this._geom_st_box2d;
    }

    public set geom_st_box2d(value: string) {
        this._geom_st_box2d = value;
    }

    public get num(): string {
        return this._num;
    }

    public set num(value: string) {
        this._num = value;
    }

    public get y(): string {
        return this._y;
    }

    public set y(value: string) {
        this._y = value;
    }

    public get x(): string {
        return this._x;
    }

    public set x(value: string) {
        this._x = value;
    }

    public get lat(): string {
        return this._lat;
    }

    public set lat(value: string) {
        this._lat = value;
    }

    public get lon(): string {
        return this._lon;
    }

    public set lon(value: string) {
        this._lon = value;
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: string) {
        this._label = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    deserialize(restObject: any): TSGeoadminSearchResponse {
        this.origin = restObject.origin;
        this.layerBodId = restObject.layerBodId;
        this.featureId = restObject.featureId;
        this.detail = restObject.detail;
        this.rank = restObject.rank;
        this.geom_st_box2d = restObject.geom_st_box2d;
        this.num = restObject.num;
        this.y = restObject.y;
        this.x = restObject.x;
        this.lat = restObject.lat;
        this.lon = restObject.lon;
        this.label = restObject.label;

        this.name = this.label.replace('<b>', '').replace('</b>', '')
            .replace('<i>', '').replace('</i>', '');

        return this;
    }

    serialize(restObject: any): any {
        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSGeoadminSearchResponse.ts